import React, { useContext } from 'react';
import styled from 'styled-components';
import { AuthContext } from '../../../../App';
import KnownUsersUtils from '../../../../utils/user/KnownUsers.ts/KnownUsersUtils';
import { blue6 } from '../../../colors/COLORS';
import { MeetingData, MeetingVersion } from '../../../types/types';
import ReactTooltip from '../../tooltip/ReactTooltip';
import TOOLBAR_BREAKPOINTS from './TextEditorConstants';

const Container = styled.span`
  color: ${blue6};

  @media (min-width: ${TOOLBAR_BREAKPOINTS.STRIKE_INDENT_CLEAR}px) {
    margin-left: 4px;
  }
`;

interface Props {
  meetingData: MeetingData;
}

const MeetingVersionNumber = ({ meetingData }: Props) => {
  const authData = useContext(AuthContext);
  if (meetingData.resolvedState !== 'resolved') return null;
  if (!KnownUsersUtils.isKnownUser(authData.userId)) return null;

  const tooltipText = generateMeetingVersionTooltipText(meetingData.version);

  return (
    <ReactTooltip tip={tooltipText} place="left" textEditor>
      <Container>
        {meetingData.version}
      </Container>
    </ReactTooltip>
  );
};

export default MeetingVersionNumber;

const generateMeetingVersionTooltipText = (meetingVersion: MeetingVersion) => {
  let versionText = `${meetingVersion}`;
  if (meetingVersion === 5) {
    versionText = '5 (latest)';
  }
  return `This meeting is currently using the version ${versionText} text editor.`;
};
